import React from 'react';
import { Monogram } from './Monogram';
type LogoProps = {
  tone?: 'light' | 'dark';
};
export function Logo({
  tone = 'light'
}: LogoProps) {
  const word = tone === 'light' ? 'text-white' : 'text-navy';
  const sub = tone === 'light' ? 'text-gold' : 'text-gold-deep';
  const rule = tone === 'light' ? 'bg-white/20' : 'bg-navy/15';
  return <span className="flex items-center gap-3.5" data-id="element-26" data-mp="1rmjes0w2igxv">
      <Monogram tone={tone} className="h-9 w-9 shrink-0" data-id="element-27" data-mp="u02ohflr53lm" />
      <span aria-hidden="true" className={`h-9 w-px ${rule}`} data-id="element-28" data-mp="u1nd6oldxsbk" />
      <span className="flex flex-col leading-none" data-id="element-29" data-mp="yzf6nn1ohmhv">
        <span className={`font-serif text-[23px] font-semibold tracking-[0.22em] ${word}`} data-id="element-30" data-mp="13xqi227mg527">AVENQOR</span>
        <span className={`mt-1.5 text-[9px] font-semibold tracking-[0.38em] ${sub}`} data-id="element-31" data-mp="18wjx3z2k444h">TALENT SEARCH</span>
      </span>
    </span>;
}